@if (loading()) {
  <mat-progress-spinner color="accent" mode="indeterminate" [diameter]="20" />
} @else if (displayErrorMessage()) {
  <span class="entity-cell--error-message">N/A</span>
} @else {
  <span class="entity-cell">{{ dataToDisplay() | infoDisplay }}</span>
}
